export const VERSION = "v4.49.0";
